import React, { useEffect, useRef, useState } from "react";
import { InfoMediaContactingBoard, TitleWrap, FormContactingBoard } from "../../components";
import { useTranslation } from 'react-i18next';

const TeamContactUs = (props) => {
  const { t, i18n } = useTranslation();
  const contactArea = useRef(null);
  const [lang, setLang] = useState();

  useEffect(() => {
    if (localStorage.getItem('cheese_lang')) {
      setLang(localStorage.getItem('cheese_lang'));
    } else {
      setLang('th');
    }
  }, []);

  const scrollHandler = (event) => {
    event.preventDefault();
    let targetOffset = contactArea.current.offsetTop - 200;
    window.scrollTo({
      behavior: "smooth",
      top: targetOffset,
    });
  };

  window.addEventListener('storage', () => {
    if (localStorage.getItem('cheese_lang')) {
      setLang(localStorage.getItem('cheese_lang'));
    } else {
      setLang('th');
    }
  });

  return (
    <div>
      <div className="container mb-100px">
        <TitleWrap className="text-center">
          <div class="d-flex justify-content-center pt-60px">
            <h1 class="title-line">{t('contact_us')}</h1>
          </div>
        </TitleWrap>
        <div className="row">
          <div className="col-lg-6 mb-30">
            <div className="contact-box">
              <InfoMediaContactingBoard
                icon="far fa-map-marker-alt"
                title={t('address')}
                info={t('company_address')}
              />

              <InfoMediaContactingBoard
                icon="fal fa-phone-alt"
                title={t('phone')}
                info={
                  <>
                    <a href="tel:+310259121563">0-2530-0185</a>
                  </>
                }
              />
              <InfoMediaContactingBoard icon="far fa-fax" title={t('fax')} info="0-2530-0172" />
              <InfoMediaContactingBoard icon="fas fa-envelope" title="E-mail" info="admin@cheesediginet.com " />
              <InfoMediaContactingBoard icon="fas fa-map-marked-alt" title="Google Map" info="" ggmap="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d242.17844323657727!2d100.611109!3d13.7876077!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29dfa880f76e3%3A0x1b675ab79e00ba6b!2z4Lia4Lij4Li04Lip4Lix4LiXIOC4iuC4teC4quC5guC4oeC4muC4suC4oiDguITguK3guKPguYzguYDguJvguK3guKPguYzguYDguKPguIrguLHguYjguJkg4LiI4Liz4LiB4Lix4LiU!5e0!3m2!1sth!2sth!4v1684937604980!5m2!1sth!2sth" />
             
            </div>
          </div>
          <div className="col-lg-6 mb-30">
            <div className="contact-box">
            <FormContactingBoard contactType={props.contactType} langauge={lang} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamContactUs;
